module.exports = __webpack_public_path__ + "static/media/IMG_1819.bafb32e7.JPG";